// extracted by mini-css-extract-plugin
module.exports = {"menu":"Layout_menu__zxfR5","main":"Layout_main__E16O_","menuCollapsed":"Layout_menuCollapsed__0llxE"};